module.exports = __webpack_public_path__ + "img/8.05712409.png";